<template>
  <screen
    v-show="show"
    :show-intro.sync="showIntro"
    :intro-duration="5"
    :screen-name="screenName"
    :screen-info="$t('stamp.clothes_info')"
    :alt-info="$t('stamp.clothes_alt_info')"
    @skip="$emit('skip')"
  >
    <clothes />
  </screen>
</template>

<script>
import incein from '@/mixins/incein';
import autoNext from '@/mixins/auto-next';

import Screen from '../Screen.vue';
import Clothes from './Clothes.vue';

export default {
  name: 'ThingsToNote1',
  components: { Screen, Clothes },
  mixins: [autoNext, incein],
  data: () => ({
    audioKey: 'Voice2', // play intro first on show
    duration: 13,
    showIntro: true,
    playThrough: false,
  }),
  computed: {
    screenName() {
      return this.isIncein
        ? this.$t('incein.things_to_note_title')
        : this.$t('stamp.things_to_note_title');
    },
  },
  watch: {
    showIntro(nv, ov) {
      if (!nv && ov) {
        this.playAudio('8');
      }
    },
  },
};
</script>
